/**
 * Labstep
 */

import type { ParamsHOCChildrenProps } from 'labstep-web/hoc/Params/types';
import isEmpty from 'lodash/isEmpty';
import omit from 'lodash/omit';

export const getHasFilterActive = (
  searchParams: ParamsHOCChildrenProps['searchParams'],
  showSearchQuery?: boolean,
): boolean => {
  const ignore = [
    'sort',
    'page',
    'folder_id',
    'is_unsorted',
    'template_id',
    'has_template',
  ];
  if (!showSearchQuery) {
    ignore.push('search_query');
  }
  // we ignore filter if there's a filter with no user-defined predicates
  // this means that there are system-defined predicates
  if (
    Array.isArray(searchParams.filter) &&
    searchParams.filter[0] &&
    Array.isArray(searchParams.filter[0].predicates) &&
    searchParams.filter[0].predicates.length === 0
  ) {
    ignore.push('filter');
  }
  return !isEmpty(omit(searchParams, ignore));
};
